import { createSlice, current } from '@reduxjs/toolkit';
import { showSuccessToast } from '../../app/utils/tostify';
import { t } from 'i18next';
import {
	addProduct,
	checkItemNumber,
	deleteProductList,
	deleteProductVariant,
	editProductDetails,
	getInventoryProductList,
	getProductList,
	updataeProductStatus
} from '../apis/ProductAPIs';
import { showSuccess } from '../../app/utils/sweetAlert';
interface initialStateInterFace {
	error: any;
	loading: boolean;
	allTheData: any;
	advanceData: any;
	productList: Array<any>;
	inventoryProductList: Array<any>;
	currentPage: number;
	count: number;
	selectedList: any;
	searchKey: string;
	searchKeyInventory: string;
}
const initialState: initialStateInterFace = {
	loading: false,
	error: [],
	allTheData: {},
	advanceData: {},
	productList: [],
	inventoryProductList: [],
	currentPage: 1,
	count: 0,
	selectedList: { varientList: [], mainproductList: [] },
	searchKey: '',
	searchKeyInventory: ''
};
const productSlice = createSlice({
	name: 'productSlice',
	initialState,
	reducers: {
		removeAllData(state, action) {
			state.error = action.payload;
		},
		addDataInTheLocalState(state, action) {
			state.allTheData = action.payload;
		},
		updataAllData(state, action) {
			const data = structuredClone(current(state?.allTheData));
			data.managedVariantData[action.payload.index] =
				action?.payload?.data;
			state.allTheData = data;
		},
		updatePorductList(state, action) {
			state.productList = action?.payload;
		},
		addDataInTheLocalStateAdvance(state, action) {
			state.advanceData = action.payload;
		},
		addDataIntoTheList(state, action) {
			if (
				action.payload.type == 'VARIENT' ||
				action.payload.type == 'MAIN'
			) {
				switch (action.payload.type) {
					case 'VARIENT':
						state.selectedList.varientList.push(
							action.payload.data
						);
						state.selectedList.varientList =
							state.selectedList.varientList.filter(
								(item: any) => item
							);
						// !state.selectedList.varientList.map((item: any) => item.id).includes(action.payload.data.id) ?
						//     state.selectedList.varientList.push(action.payload.data) :
						//     state.selectedList.varientList = state.selectedList.varientList.filter((i: any) => i.id !== action.payload.data.id);
						// console.log(action.payload.product._id, action.payload?.product.product_variants?.length, 5656);
						// if (state.selectedList.varientList.length == action.payload.product?.product_variants?.length) {
						//     console.log(action.payload.product._id, action.payload.product, 5656);
						//     !state.selectedList.mainproductList.map((item: any) => item.id).includes(action.payload.product._id) ?
						//         state.selectedList.mainproductList.push({ id: action.payload.product._id, is_active: action.payload.product.is_active }) :
						//         state.selectedList.mainproductList = state.selectedList.mainproductList.filter((i: any) => i.id !== action.payload.product._id)
						// }
						break;
					case 'MAIN':
						!state.selectedList.mainproductList
							.map((item: any) => item.id)
							.includes(action.payload.data.id)
							? state.selectedList.mainproductList.push(
									action.payload.data
							  )
							: (state.selectedList.mainproductList =
									state.selectedList.mainproductList.filter(
										(i: any) =>
											i.id !== action.payload.data.id
									));
						break;
					default:
						break;
				}
			}
		},
		addItemToList(state, action) {
			switch (action.payload.type) {
				case 'VARIENT':
					state.selectedList.varientList.push(action.payload.data);
					state.selectedList.varientList =
						state.selectedList.varientList.filter(
							(item: any) => item
						);
					break;
				case 'MAIN':
					state.selectedList.mainproductList.filter(
						(i: any) => i.id !== action.payload.data.id
					);
					state.selectedList.mainproductList.push(
						action.payload.data
					);
					state.selectedList.mainproductList =
						state.selectedList.mainproductList.filter(
							(obj: any, index: any) =>
								state.selectedList.mainproductList.findIndex(
									(item: any) => item.id === obj.id
								) === index
						);
					break;
				default:
					break;
			}
		},
		removeDataIntoTheList(state, action) {
			switch (action.payload.type) {
				case 'VARIENT':
					state.selectedList.varientList =
						state.selectedList.varientList.filter(
							(i: any) => i.id !== action.payload.data.id
						);
					break;
				case 'MAIN':
					state.selectedList.mainproductList =
						state.selectedList.mainproductList.filter(
							(i: any) => i.id !== action.payload.data.id
						);
					break;
				default:
					break;
			}
		},
		addALlLnTheList(state, action) {
			state.selectedList.varientList = action.payload.varientList;
			state.selectedList.mainproductList = action.payload.mainproductList;
		},
		updateCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		handleSearchKey(state, action) {
			state.searchKey = action.payload;
		},
		handleSearchKeyInventory(state, action) {
			state.searchKeyInventory = action.payload;
		}
	},
	extraReducers: (builder) => {
		// builder.addCase(checkItemNumber.pending, (state) => {
		//     state.loading = true;
		// });
		builder.addCase(checkItemNumber.fulfilled, (state) => {
			state.loading = false;
		});
		builder.addCase(checkItemNumber.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(
			getProductList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
				state.advanceData = {};
				state.allTheData = {};
			}
		);
		builder.addCase(
			getProductList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.productList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getProductList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(addProduct.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addProduct.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addProduct.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(
			editProductDetails.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			editProductDetails.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			editProductDetails.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			updataeProductStatus.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			updataeProductStatus.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			updataeProductStatus.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			getInventoryProductList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
				state.advanceData = {};
				state.allTheData = {};
			}
		);
		builder.addCase(
			getInventoryProductList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.inventoryProductList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getInventoryProductList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			deleteProductList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			deleteProductList.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				// showSuccessToast({ message: t(action.payload.message) })
			}
		);
		builder.addCase(
			deleteProductList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			deleteProductVariant.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			deleteProductVariant.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				// showSuccessToast({ message: t(action.payload.message) }), action: any
			}
		);
		builder.addCase(
			deleteProductVariant.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
	}
});
export const {
	removeAllData,
	addItemToList,
	addDataInTheLocalState,
	updatePorductList,
	addDataInTheLocalStateAdvance,
	updataAllData,
	addDataIntoTheList,
	addALlLnTheList,
	removeDataIntoTheList,
	updateCurrentPage,
	handleSearchKey,
	handleSearchKeyInventory
} = productSlice.actions;
export default productSlice.reducer;
